import React from 'react';
import PropTypes from 'prop-types';
import sprite from '../../img/sprites.svg';
import './button.scss';
import './spinner.scss';

const Button = ({ children, buttonBg, tableClass, loading, icon, iconSvg, iconColor, iconAlt, btnSize, textSize, btnRadius, ...props }) => {

  const buttonTypeClass = buttonBg ? `btn-${[buttonBg]}` : '';
  const tableClasses = tableClass && tableClass;
  const loadingClass = loading && 'loading';
  const sizeBtn = btnSize ? `btn--${btnSize}` : '';
  const sizeText = textSize ? `btn--fs-${textSize}` : '';
  const radius = btnRadius ? `btn--rounded-${btnRadius}` : '';
  const colorIcon = iconColor ? `icon--${iconColor}` : '';
  const iconClasses = [colorIcon].filter(Boolean).join(' ');
  const classes = [buttonTypeClass, loadingClass, tableClasses, sizeBtn, sizeText, radius].filter(Boolean).join(' ');

  return (
    <button className={`btn ${classes}`} {...props}>
      {icon && <img src={icon} alt={iconAlt} />}
      {iconSvg &&
        <svg className={`icon ${iconClasses}`}><use href={`${sprite}#${iconSvg}`}></use></svg>
      }
      <span className='btn__text'>{children}</span>
      <span className='btn__spinner'>
        <svg className="spinner" viewBox="0 0 50 50">
          <circle className="path" cx="25" cy="25" r="20" fill="none" strokeWidth="5"></circle>
        </svg>
      </span>
    </button> 
  );
};

Button.propTypes = {
  children: PropTypes.any,
  buttonBg: PropTypes.string,
  loading: PropTypes.string,
  icon: PropTypes.string,
  iconAlt: PropTypes.string,
  tableClass: PropTypes.string,
  btnSize: PropTypes.string,
  textSize: PropTypes.string,
  btnRadius: PropTypes.string,
  iconSvg: PropTypes.string,
  iconColor: PropTypes.string,
};

export default Button;